// Handle Skoda User Login - Frontend API call
// Calls the backend function to process Skoda OIDC user after Firebase Auth

import firebaseFunctionApi from "../../constants/firebaseFunctionApi";
import firebaseEndpoints from "../../constants/firebaseEndpoints";
import { mapSkodaProfileToUserData } from "../../constants/skodaConfig";

/**
 * @param {string} firebaseUid - The Firebase Auth UID of the authenticated user
 * @param {Object} oidcProfile - The raw OIDC profile from Firebase Auth's getAdditionalUserInfo()
 * @param {Object} tokenClaims - Claims from the raw OIDC ID token (roles) that Firebase strips from the profile
 */
export default async (firebaseUid, oidcProfile, tokenClaims = {}) => {
  // Map the raw OIDC profile and merge in token claims (roles) that Firebase strips
  const skodaProfile = mapSkodaProfileToUserData(oidcProfile, tokenClaims);

  const response = await firebaseFunctionApi(
    firebaseEndpoints.handleSkodaUserLogin.url,
    {
      firebaseUid,
      skodaProfile,
    },
    firebaseEndpoints.handleSkodaUserLogin.method,
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to process Skoda login: ${response.status}`);
  }

  return response.json();
};
